import { Lightning, Utils } from '@lightningjs/sdk';
import { MainMenuItem } from './MainMenuItem';
import { Theme } from '../../../config/theme';
import { ProfileItem } from './ProfileItem';
import { TestCmsPage } from '../../TestCmsPage';
import { ProfilePage } from '../../profile/ProfilePage';

export class ProfileMenu extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      ActiveProfile: {
        type: ProfileItem,
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        alpha: 0,
        signals: {
          onActivate: 'activeProfileActivated',
        },
      },
      ChangeCatalog: {
        type: MainMenuItem,
        x: 0,
        y: 0,
        w: w => w,
        icon: Utils.asset('images/menu/SWITCH_CATALOG_ICON.png'),
        alpha: 0,
        signals: {
          onActivate: 'menuItemActivated',
        },
        item: {
          name: 'Change Catalog',
        },
      },
      Logon: {
        type: MainMenuItem,
        x: 0,
        y: 80,
        w: w => w,
        icon: Utils.asset('images/menu/LOGIN_ICON.png'),
        alpha: 0,
        signals: {
          onActivate: 'menuItemActivated',
        },
        item: {
          name: 'Logon',
        },
      },
    };
  }

  static _states() {
    return [
      class Authorized extends this {
        $enter() {
          this.tag('ActiveProfile').setSmooth('alpha', 1);
        }
        $exit() {
          this.tag('ActiveProfile').setSmooth('alpha', 0);
        }
        _getFocused() {
          return this.tag('ActiveProfile');
        }
        activeProfileActivated() {
          this.fireAncestors('$openModal', ProfilePage, {
            backend: this.profileData.backend,
            name: 'Select profile page',
          });
        }
      },
      class Unauthorized extends this {
        $enter() {
          this.tag('ChangeCatalog').setSmooth('alpha', 1);
          this.tag('Logon').setSmooth('alpha', 1);
          this.loginHasFocus = true;
        }
        $exit() {
          this.tag('ChangeCatalog').setSmooth('alpha', 0);
          this.tag('Logon').setSmooth('alpha', 0);
        }
        _getFocused() {
          return this.loginHasFocus ? this.tag('Logon') : this.tag('ChangeCatalog');
        }
        _handleUp() {
          if (this.loginHasFocus) {
            this.loginHasFocus = false;
            return true;
          }
          return false;
        }
        _handleDown() {
          if (!this.loginHasFocus) {
            this.loginHasFocus = true;
            return true;
          }
          return false;
        }
        menuItemActivated(nav) {
          this.fireAncestors('$openPage', TestCmsPage, {
            backend: this.profileData.backend,
            name: nav.item.name,
          });
        }
      },
    ];
  }

  /**
   * initialize the profile menu component with profile data
   * @param {MenuProfileData} profileData
   */
  initialize(profileData) {
    this.profileData = profileData;
    const backend = this.profileData.backend;
    const trn = backend.translations;
    this.tag('ChangeCatalog').label = trn.forKey('catalog_select_title');
    this.tag('Logon').label = trn.forKey('login_login');
    this.tag('ActiveProfile').label = this.profileData.displayName;
    this.tag('ActiveProfile').avatar = this.profileData.avatarURL;
    this.authorized = this.profileData.isAuthorized;
  }

  set authorized(value) {
    value ? this._setState('Authorized') : this._setState('Unauthorized');
  }
}
